import React from "react";
import Header from "../../layout/Header/Header";
import Footer from "../../layout/Footer/Footer";
import MostrarOptimo from "../Mostrar/MostrarOptimo";
import imagenes from "../../assets/Imagenes";
import "../../styles/index.css"
import WhatsAppButton from "../../components/BtnWhatsapp/Whatsapp";
const Forestaciones = () => {
	return (
		<>
			<Header />
			<section className="section-todas-pesnias">
			<img src={imagenes.op7} className="banner-todas-pestanias" alt="" />
			</section>
			<h1 className="titulo-h1">Forestaciones</h1>
			<MostrarOptimo tipo="forestaciones"/>
			<Footer />
		</>
	);
};

export default Forestaciones;
